/** Marker on cacheable-route Nitro rules; stripped before the response leaves origin. */
export const CACHEABLE_ROUTE_HEADER = 'x-spilnu-cacheable'

const KNOWN_CRAWLER_PATTERN = /\b(?:Googlebot|Bingbot|GPTBot|OAI-SearchBot|ChatGPT-User|ClaudeBot|Claude-User|Claude-SearchBot|Claude-Web|anthropic-ai|PerplexityBot|Perplexity-User|Google-Extended|GoogleOther|Applebot|Applebot-Extended|CCBot|Bytespider|DuckDuckBot|YandexBot|facebookexternalhit|Meta-ExternalAgent|Meta-ExternalFetcher|Amazonbot|DeepSeekBot|DeepSeek-User|MistralBot|MistralAI|cohere-ai)\b/i

/**
 * Detects known search and answer-engine crawlers from a User-Agent.
 * Used for bot-stable experiment assignment and crawler-only cache eligibility.
 */
export function isKnownCrawler(userAgent: string | undefined | null): boolean {
    if (!userAgent) return false

    return KNOWN_CRAWLER_PATTERN.test(userAgent)
}
